// Small synchronous routing boundary. GPU code stays lazy; capture keeps its own SVG target.
let active = null;
let defaultSurface = null;

/** Called only for the live plan, before falling back to the SVG renderer. */
export function installDefaultPlanSurface(activate) {
  if (defaultSurface) throw new Error('A default plan surface is already installed.');
  if (typeof activate !== 'function') throw new TypeError('An activation callback is required.');
  defaultSurface = activate;
  return () => { if (defaultSurface === activate) defaultSurface = null; };
}
export function claimPlanSurface(render, { maxScale = Infinity } = {}) {
  if (active) throw new Error('A plan surface is already active.');
  if (typeof render !== 'function') throw new TypeError('A render callback is required.');
  if (!(maxScale > 0)) throw new RangeError('Invalid plan surface scale limit.');
  const claim = {render, maxScale}; active = claim;
  return () => { if (active === claim) active = null; };
}
export function renderActivePlanSurface(options) {
  if (!active) defaultSurface?.();
  if (!active) return false;
  active.render(options); return true;
}

export function planSurfaceMaxScale(fallback) {
  return Math.min(fallback, active?.maxScale ?? fallback);
}
